module.exports = __webpack_public_path__ + "img/icon-memo.5c551727.svg";